import { SEE_ALL } from './PageSection';

export const ImageTypes = ['poster', 'square', 'wide'] as const;
export type ImageType = (typeof ImageTypes)[number];

export type PromoImageType = 'promo-wide-large' | 'promo-wide' | ImageType;

export const AspectRatioMap: Record<PromoImageType, { height: number; width: number }> = {
  poster: { height: 3, width: 2 },
  square: { height: 1, width: 1 },
  wide: { height: 9, width: 16 },
  ['promo-wide']: { height: 9, width: 21 },
  ['promo-wide-large']: { height: 9, width: 30 },
};

export const getAspectRatio = (imageType: PromoImageType) => AspectRatioMap[imageType];

export const getAspectRatioStr = (imageType: PromoImageType, separator = '/') => {
  const aspectRatio = AspectRatioMap[imageType];
  return `${aspectRatio.width}${separator}${aspectRatio.height}`;
};

export type UploadImageDTO = {
  id: string;
  location: string;
};

export const SEE_ALL__IMAGE_LOCATION = `/images/editorial/${SEE_ALL}`;

export const RESERVED_IMAGE_LOCATIONS = {
  [SEE_ALL]: SEE_ALL__IMAGE_LOCATION,
};
